import { errHandler } from "utils/common";
import api from "utils/api";

export default class DataDasarFaskes {
  getAll = (opt = { searchBy: "", searchValue: "", page: 1, limit: 10 }) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/basic-data-fasyankes`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/basic-data-fasyankes?device=Online", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  update = (payload, id) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/basic-data-fasyankes/${id}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
